import { formatStatus, formatBidBudget, formatEmail } from '@bingads-webui-campaign/bulk-operation-base';

const PauseActionValue = {
  Campaign: 'UserPaused',
  Ad: 'Paused',
  AdGroup: 'Paused',
  Keyword: 'Paused',
  AssetGroup: 'Paused',
};

export class EntitySettingBase {
  constructor({
    entity,
    i18n,
    selectedRule,
    accountCurrencyCode,
    bidBudgetRange,
  }) {
    this.i18n = i18n;
    this.menuAction = selectedRule.action;
    this.selectedRule = selectedRule;
    this.bidBudgetRange = bidBudgetRange;
    this.accountCurrencyCode = accountCurrencyCode;
    this.entity = entity;

    if (this.isActionNoneText()) {
      this.actionView = this.createActionView();
    } else {
      this.actionView = null;
    }

    if (this.isActionNoneText()) {
      this.setPreviewErrorHeaders();
    } else {
      this.previewOldHeader = i18n.getString('BulkEdit_OldStatusHeader');
      this.previewNewHeader = i18n.getString('BulkEdit_NewStatusHeader');
      this.previewAttempedHeader = i18n.getString('BulkEdit_AttemptedStatusHeader');
    }

    this.setUpPreviewEntityNameAndEntityKey();
  }

  getActionView() {
    return this.actionView;
  }

  isActionText() {
    return !this.isActionNoneText();
  }

  isActionNoneText() {
    return false;
  }

  setUpPreviewEntityNameAndEntityKey() {
    this.previewEntityName = this.i18n.getString('BulkEdit_Ad_EntityNameHeader');
    this.previewEntityKeys = ['AdTitle', 'AdHeadline'];
    this.defaultEntityValue = `{${this.i18n.getString('Ad_DSA_Title')}}`;
  }

  formatPreviewResults(results) {
    if (this.isActionNoneText()) {
      return formatBidBudget(results, this.previewEntityKeys, this.i18n);
    } else if (this.menuAction === 'Enable' || this.menuAction === 'Pause') {
      return formatStatus(
        results,
        this.previewEntityKeys,
        this.i18n,
        this.defaultEntityValue,
        this.entity
      );
    }
    return formatEmail(results, this.previewEntityKeys, this.defaultEntityValue);
  }

  setPreviewErrorHeaders() {
  }

  getPreviewHeaders() {
    return this.menuAction === 'SendEmail' ?
      [this.previewEntityName] :
      [this.previewEntityName, this.previewOldHeader, this.previewNewHeader];
  }

  isActionValidate() {
    return !this.isActionNoneText() || this.actionView.validate();
  }

  getAction() {
    if (this.isActionNoneText()) {
      return this.actionView.getUserAction();
    }

    switch (this.menuAction) {
      case 'Enable':
        return {
          Actions: [{
            '@odata.type': '#Model.TextAction',
            Property: 'Status',
            ActionType: 'Set',
            Value: 'Active',
          }],
        };
      case 'Pause':
        return {
          Actions: [{
            '@odata.type': '#Model.TextAction',
            Property: 'Status',
            ActionType: 'Set',
            Value: PauseActionValue[this.entity],
          }],
        };
      case 'SendEmail':
        return {
          Actions: [{
            '@odata.type': '#Model.QueryOnlyAction',
          }],
        };
      default:
        return null;
    }
  }
}
